import { connectorActionWording, connectorDisplayName } from "@amoreg/shared/connectorActions";

/** Older saved approvals already have details, but their summary names the raw action. */
export function compactApprovalTitle(summary: string, details?: string): string {
  if (!details?.startsWith("plugins_execute_action — ") || !/^Run "/.test(summary)) return summary;
  const field = (name: string): string | null => {
    const match = new RegExp(`(?:— |, )"${name}": ("(?:[^"\\\\]|\\\\.)*")(?=, |$)`).exec(details);
    if (!match) return null;
    try {
      return JSON.parse(match[1]!);
    } catch {
      return null;
    }
  };
  const connector = field("connectorId");
  const slug = field("toolSlug");
  if (!connector || !slug) return summary;
  const title = connectorActionWording(slug, connector).title;
  return `${title.charAt(0).toUpperCase()}${title.slice(1)} · ${connectorDisplayName(connector)}`;
}
